<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box selectOrdersForSchedulingCard">
                <div class="text-danger" v-if="ordersToScheduleErrorMessage.showErrorMessage">
                    {{ordersToScheduleErrorMessage.message}}
                </div>
                <div v-show="!loading">
                    <div class="form-group">
                        <label>Expected Date of Delivery</label>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="expectedDateOfDelivery"
                                     :initialiseDate="initialiseDate"
                                     @dateChange="onExpectedDateOfDeliverySelect"></date-picker>
                    </div>
                    <data-table
                            :headings="deliveryOrdersHeadings"
                            :data="deliveryOrders"
                            :hasNoFilter="true"
                            :stateChanged="false"
                            :hasActions="true"
                            :hasCustomActionComponent="true"
                            :pagingDetails="pagingDetails"
                            @pagingUpdated="onPagingUpdated">
                        <template #actionComponent="{ orderId, selectedForScheduling }">
                            <input type="checkbox" :checked="selectedForScheduling" @change="onOrderSelect(orderId, selectedForScheduling)">
                        </template>
                    </data-table>
                    <br>
                    <br>
                    <div class="float-right mb-3">
                        <button class="btn btn-primary" @click="onScheduleOrdersButtonClick">
                            Schedule Orders
                        </button>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
</div>
